import { useCallback, useState } from 'react';
const STORAGE_KEY = 'PORTALS_SIDE_NAV_EXPANDED';
function readStoredExpanded() {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    // Default to collapsed when the user has not made a choice yet.
    return stored === null ? false : stored === 'true';
  } catch (_unused) {
    return false;
  }
}
function writeStoredExpanded(value) {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, String(value));
  } catch (_unused2) {
    // Ignore storage failures (private mode, disabled storage, etc.).
  }
}

/**
 * Tracks whether the desktop side nav is expanded (icons + labels) or
 * collapsed (icon-only rail). The choice is persisted in localStorage so it
 * survives reloads. Defaults to collapsed.
 */
export function useSideNavExpanded() {
  const [isExpanded, setIsExpanded] = useState(readStoredExpanded);
  const toggle = useCallback(() => {
    setIsExpanded(prev => {
      const next = !prev;
      writeStoredExpanded(next);
      return next;
    });
  }, []);
  return [isExpanded, toggle];
}